// src/features/permissions/PermissionWorkspacePage.tsx
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { PageContainer } from '../../app/components/foundation';
import {
  PermissionWorkspaceHeader,
  RoleInfoCard,
  PermissionListCard,
  UserAccessCard,
  ModuleAccessCard,
  PermissionTimelineCard,
} from './components';
import { getSecurityRoles } from '../security/api/security.api';
import type { SecurityRole } from '../security/types/security.types';
import './styles/permissions.css';

/**
 * Permissions Workspace Foundation (/permissions/:id). Same shell
 * pattern as ServiceWorkspacePage/CommissionWorkspacePage/
 * MonitoringWorkspacePage/AnalyticsWorkspacePage: PageContainer +
 * feature-owned header, card grid below, RTL/Persian throughout,
 * existing tokens/primitives only.
 *
 * Reads the real role list endpoint and selects the requested role by
 * role_id. Permission details remain structured and scope-aware.
 */
export function PermissionWorkspacePage() {
  const { id } = useParams<{ id: string }>();
  const [roles, setRoles] = useState<SecurityRole[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    getSecurityRoles()
      .then(setRoles)
      .catch(() => setError('خطا در دریافت اطلاعات نقش'))
      .finally(() => setLoading(false));
  }, []);

  const record = roles.find((role) => String(role.role_id ?? role.id) === id);

  if (!record) {
    return (
      <PageContainer className="flex flex-col gap-6">
        <p className="vania-permissions-workspace-empty">{loading ? 'در حال بارگذاری نقش...' : error || 'نقش مورد نظر یافت نشد.'}</p>
      </PageContainer>
    );
  }

  return (
    <PageContainer className="flex flex-col gap-6">
      <PermissionWorkspaceHeader role={record} />

      <div className="vania-permissions-workspace-grid">
        <RoleInfoCard role={record} />
        <PermissionListCard permissions={record.permission_details} />
        <UserAccessCard users={[]} />
        <ModuleAccessCard modules={[]} />
        <PermissionTimelineCard timeline={[]} />
      </div>
    </PageContainer>
  );
}
